import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import BasicPageComponent from '../BasicPageComponent';
import EditGrid from '../ui/EditGrid/EditGrid';
import * as apiDashBoardService from './apiRequestService';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { getProcessGroups } from '../ProcessGroup/apiRequestService';
import { GridColumns } from './GridColumns';

class ProcessType extends Component {
    constructor(props) {
      super(props);
      this.state = {
        gridFunc:null,
        gridColumns : GridColumns,
        CRUDServices:{
          Create:apiDashBoardService.createProcessType,
          Update:apiDashBoardService.updateProcessType,
          Delete:apiDashBoardService.deleteProcessTypeById}
      };
    }
    refreshList(){
      apiDashBoardService.getProcessTypes()
      .then((response) => {
        this.gridFunc.state.gridRows= response.data;
        this.gridFunc.state.gridColumns= this.state.gridColumns;
        this.gridFunc.state.columnVisibilityModel= {id:false};
    
        this.gridFunc.setState(this.gridFunc.state)
      })
      .catch((exception) => {
        this.props.actions.setNotification("Süreç türü bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
        console.log('getProcessTypes exception: ' + JSON.stringify(exception));
      });      
    }
    componentDidMount() {
      this.refreshList();

      getProcessGroups()
      .then((response) => {
        this.state.gridColumns.filter(item => item.field=="processGroup").map((item) =>
          item.dataList=response.data);
      })
      .catch((exception) => {
        this.props.actions.setNotification("Süreç grubu bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
        console.log('getProcessGroups exception: ' + JSON.stringify(exception));
      });        
    }
  
    closeEditPage(ele) {
      this.refreshList();
    }
    
    render() {
      const { CRUDServices } = this.state;

      return (
        <div>
          <div style = {{display: 'flex',
            flexDirection: 'column'}}>
            {/* <SideMenu2/> */}
            <BasicPageComponent
              title='SÜREÇ TÜRLERİ'
              description='Süreç Türü Tanımlama Ekranı'
              children = {
                <ScreenContainer>
              <EditGrid ref={instance => { this.gridFunc = instance; }} dialogTitle="Süreç Türleri" gridHeight={400} {...this.props} CRUD={CRUDServices} 
              LoadData={(e) => this.closeEditPage(e)}/>
              </ScreenContainer>
              }
            />       
          </div>
        </div>
      );
    }
  }

  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
  });

  export default compose(
    connect(
      null,
      mapDispatchToProps
    )
  )(ProcessType);